import { render, staticRenderFns } from "./roster.vue?vue&type=template&id=0e6a2940&scoped=true&"
import script from "./roster.vue?vue&type=script&lang=ts&"
export * from "./roster.vue?vue&type=script&lang=ts&"
import style0 from "./roster.vue?vue&type=style&index=0&id=0e6a2940&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6a2940",
  null
  
)

export default component.exports